import React, { Component } from 'react';
import { Label } from 'atoms/Texts';
import { FormSelect } from 'atoms/Inputs'
import Breadcrumb from 'molecules/Breadcrumb';
import DataTables from 'organisms/DataTable';
import {
  notifTitleFormatter,
  notifBodyFormatter,
  notifDateFormatter
} from 'molecules/TableFormatters'
import { Types, Periods } from 'fixtures/enums'
import { notifRouteHelper } from 'helpers/notifNavigateHelper'
import { getAllNotifs, getFilteredNotifs, updateReadNotifs } from 'Redux/actions/NotifActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, TableWrapper, FilterCol, FilterRow } from './styles';
import { withTheme } from 'styled-components';
import { withRouter } from 'react-router-dom';

class NotifList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectConfig: {
        mode: 'radio',
        clickToSelect: true,
        clickToEdit: true,
        hideSelectColumn: true,
        onSelect: this.onSelectItem.bind(this),
        style: { backgroundColor: this.props.theme.getRGBA(this.props.theme.mocaPurple, 0.19) }
      },
      filter: {
        type: Types[0].value,
        period: Periods[0].value
      },
      navList: ['Notification']
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllNotifs()
  }

  componentDidUpdate(prevProps) {
    const { notifications, viewState: { isLoading } } = this.props
    if (prevProps.notifications !== notifications && isLoading) {
      this.props.toggleIsLoading(false)
    }
  }

  // method for applying the filter
  onFilterChange(val, field) {
    const filterObj = Object.assign(this.state.filter)
    filterObj[field] = val
    this.setState({ filter: filterObj }, () => {
      this.props.getFilteredNotifs(this.state.filter)
    })
  }

  // method on selecting notif item
  onSelectItem(row, isSelect, rowIndex, e) {
    const { history: { push } } = this.props
    const { action: { id: itemId }, type, id: notifId } = row
    const fullRoute = notifRouteHelper(type, itemId)
    this.props.updateReadNotifs(notifId)
    push(fullRoute)
  }

  // rendering the filter row
  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: '234px',
      yxPadding: '9px 12px',
      height: '34px',
    }

    const { filter: { type, period } } = this.state

    return (
      <FilterRow>
        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Filter Issue
          </Label>
          <FormSelect
            placeholder={'Select issue'}
            onChangeVal={e => this.onFilterChange(e.target.value, 'type')}
            options={Types}
            value={type}
            valField={'value'}
            dispField={'name'}
            arrowSize={'8%'}
            {...inputConfig}
          />
        </FilterCol>

        <FilterCol>
          <Label lineheight={'14px'} size={'12px'}>
            Period
          </Label>
          <FormSelect
            placeholder={'Select period'}
            onChangeVal={e => this.onFilterChange(e.target.value, 'period')}
            options={Periods}
            value={period}
            valField={'value'}
            dispField={'name'}
            arrowSize={'8%'}
            {...inputConfig}
          />
        </FilterCol>
      </FilterRow>
    )
  }

  render() {
    const { selectConfig, navList } = this.state
    const { notifications, viewState: { isLoading, isMobileView } } = this.props

    const config = [
      {
        dataField: 'title',
        text: 'Title',
        formatter: notifTitleFormatter,
        headerStyle: { display: 'none' },
      },
      {
        dataField: 'body',
        text: 'Body',
        formatter: notifBodyFormatter,
        headerStyle: { display: 'none' },
      },
      {
        dataField: 'createdAt',
        text: 'Date',
        formatter: notifDateFormatter,
        headerStyle: { display: 'none' },
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        {!isLoading &&
          <TableWrapper>
            {this.renderFilterRow()}
            <DataTables
              noStripe={true}
              noHeadings={true}
              leftSlot={null}
              dataList={notifications}
              columnConfig={config}
              selectConfig={selectConfig}
              defaultSize={5}
            />
          </TableWrapper>
        }
      </PageWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    notifications: state.notifications,
    viewState: state.viewState
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllNotifs,
      getFilteredNotifs,
      updateReadNotifs,
      toggleIsLoading
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(NotifList)
  )
);
